export enum EventPolicyTypesEnum {
	NoRefunds = 'no-refunds',
	AutoRefundUntil24hBeforeEvent = 'automatic-refund-until-24h-before-event'
}
